export default __webpack_public_path__ + "static/media/IMG-20240822-WA0021.a4c2377f.jpg";